import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import { editProductField } from 'redux/modules/products';
import { Accordion, PageHeader, Spinner } from 'components';
import NewProductForm from './NewProductForm';
import { connect, Provider, ReactReduxContext } from 'react-redux';
import * as styles from './PackageManager.scss';
import * as _ from 'lodash';
var ProductAccordion = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme,
    newProduct: state.products.newProduct || null,
    invalidFields: state.products.invalidFields
  };
}, {
  editProductField: editProductField
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(ProductAccordion, _Component);

  var _super = _createSuper(ProductAccordion);

  function ProductAccordion(props) {
    var _this;

    _classCallCheck(this, ProductAccordion);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "formatCurrency", function (amount) {
      var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var amountInDollars = cents ? amount / 100.0 : amount;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(amountInDollars);
    });

    _defineProperty(_assertThisInitialized(_this), "handleArchiveProduct", function (productId) {
      if (window.confirm('You are about to archive this product. Are you sure?')) {
        _this.props.handleArchiveProduct(productId, _this.props.selectedOrgId);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderSection", function (p) {
      var ratio = p.monthlyPriceApplicationFee / p.retailMonthlyPrice;

      var monthlyCalculatedFees = _this.doFeeCalculations(p.retailMonthlyPrice, ratio);

      var transactionFees = {
        monthly: parseFloat(p.retailMonthlyPrice) * 0.029 + 30,
        setup: p.retailSetupFee ? parseFloat(p.retailSetupFee) * 0.029 + 30 : 0
      };

      var calcAmounts = function calcAmounts(total, appFees, transactionFee) {
        var likeablelocalAmount = parseFloat(appFees);

        if (parseFloat(likeablelocalAmount) + parseFloat(transactionFee) >= parseFloat(total)) {
          likeablelocalAmount = parseFloat(total);
        }

        var partnerAmount = parseFloat(total) - likeablelocalAmount;

        if (partnerAmount < transactionFee) {
          partnerAmount = 0;
          likeablelocalAmount = parseFloat(total);
        }

        return [_.clamp(likeablelocalAmount, 0.0, parseFloat(total)), _.clamp(partnerAmount, 0.0, parseFloat(total))];
      };

      var _calcAmounts = calcAmounts(p.retailMonthlyPrice, p.monthlyPriceApplicationFee, transactionFees.monthly),
          _calcAmounts2 = _slicedToArray(_calcAmounts, 2),
          llMonthlyAmount = _calcAmounts2[0],
          partnerMonthlyAmount = _calcAmounts2[1];

      var _calcAmounts3 = calcAmounts(p.retailSetupFee, p.setupFeeApplicationFee, transactionFees.setup),
          _calcAmounts4 = _slicedToArray(_calcAmounts3, 2),
          llSetupAmount = _calcAmounts4[0],
          partnerSetupAmount = _calcAmounts4[1];

      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          padding: 16
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 24
        }
      }, p.description), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.itemWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label
      }, "Monthly Fee:"), _this.formatCurrency(p.retailMonthlyPrice)), /*#__PURE__*/React.createElement("div", {
        className: styles.itemWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label
      }, "One Time Setup Fee:"), p.retailSetupFee && p.retailSetupFee > 0 ? _this.formatCurrency(p.retailSetupFee) : 'None'), /*#__PURE__*/React.createElement("div", {
        className: styles.itemWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label
      }, "Ads Budget:"), p.adsBudget && p.adsBudget > 0 ? _this.formatCurrency(p.adsBudget) : 'None'), /*#__PURE__*/React.createElement("div", {
        className: styles.itemWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label
      }, "Likeable Local's Monthly Fee Portion:"), _this.formatCurrency(llMonthlyAmount)), /*#__PURE__*/React.createElement("div", {
        className: styles.itemWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label
      }, "Partner's Monthly Fee Portion:"), _this.formatCurrency(partnerMonthlyAmount)), /*#__PURE__*/React.createElement("div", {
        className: styles.itemWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label
      }, "Likeable Local's Setup Fee Portion:"), p.retailSetupFee && p.retailSetupFee > 0 ? _this.formatCurrency(llSetupAmount) : 'N/A'), /*#__PURE__*/React.createElement("div", {
        className: styles.itemWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label
      }, "Partner's Setup Fee Portion:"), p.retailSetupFee && p.retailSetupFee > 0 ? _this.formatCurrency(partnerSetupAmount) : 'N/A'), /*#__PURE__*/React.createElement("div", {
        className: styles.itemWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: {
          width: '100%'
        }
      }, "Total Package Price:", ' ', _this.formatCurrency(parseFloat(p.retailMonthlyPrice) + parseFloat(p.adsBudget ? p.adsBudget : 0)), "/mo", p.retailSetupFee && p.retailSetupFee > 0 ? " + One-Time Setup Fee of ".concat(_this.formatCurrency(p.retailSetupFee)) : '')), /*#__PURE__*/React.createElement("div", {
        className: styles.itemWrap
      }, /*#__PURE__*/React.createElement("small", {
        style: {
          padding: 5,
          display: 'block'
        }
      }, "* Transaction fees apply")))), /*#__PURE__*/React.createElement("div", {
        style: {
          alignSelf: 'flex-start',
          flex: '0 0 100px'
        }
      }, _this.props.products.length > 1 && /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.icon, " icon ion-ios-trash-outline"),
        onClick: function onClick() {
          return _this.handleArchiveProduct(p.id);
        }
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "doFeeCalculations", function (retailFee, ratio) {
      return _objectSpread({}, function () {
        if (retailFee <= 0) {
          return {
            likeablelocalAmount: 0,
            partnerAmount: 0,
            transactionFee: 0,
            total: 0,
            transactionFeeFrom: null
          };
        }

        var transactionFeeFrom = 'partner';
        var transactionFee = parseFloat(retailFee) * 0.029 + 0.3;
        var likeablelocalAmount = parseFloat(retailFee) * parseFloat(ratio);

        if (parseFloat(retailFee) - likeablelocalAmount < transactionFee) {
          likeablelocalAmount -= transactionFee;
          transactionFeeFrom = 'likeablelocal';
        }

        var partnerAmount = parseFloat(retailFee) - likeablelocalAmount - transactionFee;

        if (likeablelocalAmount < transactionFee) {
          partnerAmount -= transactionFee;
          likeablelocalAmount += transactionFee;
          transactionFeeFrom = 'partner';
        }

        return {
          likeablelocalAmount: likeablelocalAmount,
          partnerAmount: partnerAmount,
          transactionFee: transactionFee,
          total: likeablelocalAmount + partnerAmount + transactionFee,
          transactionFeeFrom: transactionFeeFrom
        };
      }());
    });

    _this.state = {
      showAddProductModal: false
    };
    return _this;
  }

  _createClass(ProductAccordion, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var approveModalButtons = [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: function onClick() {
          _this2.setState({
            showAddProductModal: false
          });
        },
        style: {
          marginRight: 24
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        disabled: !!this.props.invalidFields.length,
        secondary: true,
        label: "Save",
        onClick: function onClick() {
          var _this2$props$newProdu = _this2.props.newProduct,
              retailSetupFee = _this2$props$newProdu.retailSetupFee,
              setupSliderRatio = _this2$props$newProdu.setupSliderRatio,
              retailMonthlyPrice = _this2$props$newProdu.retailMonthlyPrice,
              monthlySliderRatio = _this2$props$newProdu.monthlySliderRatio;

          var _this2$doFeeCalculati = _this2.doFeeCalculations(retailMonthlyPrice, monthlySliderRatio),
              monthlyAppFee = _this2$doFeeCalculati.likeablelocalAmount;

          var _this2$doFeeCalculati2 = _this2.doFeeCalculations(retailSetupFee, setupSliderRatio),
              setupAppFee = _this2$doFeeCalculati2.likeablelocalAmount;

          Promise.all([_this2.props.editProductField('monthlyPriceApplicationFee', monthlyAppFee), _this2.props.editProductField('setupFeeApplicationFee', setupAppFee)]).then(function () {
            _this2.props.handleSaveProduct(_this2.props.newProduct);

            _this2.setState({
              showAddProductModal: false
            });
          });
        }
      })];
      return /*#__PURE__*/React.createElement("div", {
        style: this.props.style
      }, this.props.products.length ? /*#__PURE__*/React.createElement(Accordion, {
        acccordionContentStyles: {
          padding: 0
        },
        style: this.props.accordionStyle,
        sections: this.props.products.map(function (p, index) {
          return {
            id: "productAccordion_".concat(index),
            label: p.title,
            content: _this2.renderSection(p)
          };
        })
      }) : this.props.emptyState, /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Add Package",
        onClick: function onClick() {
          _this2.props.handleAddProduct();

          _this2.setState({
            showAddProductModal: true
          });
        },
        style: {
          marginTop: 24
        }
      }), /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(Dialog, {
          autoScrollBodyContent: true,
          bodyStyle: {
            marginTop: 24
          },
          contentStyle: {
            maxWidth: 990,
            width: '97%'
          },
          title: "Add Package",
          actions: approveModalButtons,
          modal: true,
          open: _this2.state.showAddProductModal
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(NewProductForm, {
          doFeeCalculations: _this2.doFeeCalculations
        })));
      }));
    }
  }]);

  return ProductAccordion;
}(Component), _defineProperty(_class2, "defaultProps", {
  style: {
    marginTop: 36
  },
  accordionStyle: {
    maxWidth: 800
  },
  emptyState: null,
  products: [],
  handleAddProduct: function handleAddProduct() {
    console.log('add product');
  },
  handleSaveProduct: function handleSaveProduct() {
    console.log('save product');
  },
  handleArchiveProduct: function handleArchiveProduct() {
    console.log('archive product');
  }
}), _temp)) || _class);
export { ProductAccordion as default };